/******************************************************
 *                  PERMISSION CHECK DIRECTIVE
 *
 * This directive checks whether html element will be
 * displayed or not given user's permissions
 ********************************************************/

"use strict";

angular.module("app").directive("permissionNeeded", [
	"$location", "$route", "SecurityService",
	function ($location, $route, SecurityService) {
	return {
		restrict: "A",
		link: function (scope, element, attributes) {

			if (!SecurityService.checkAccess(attributes.permissionNeeded)) {
				element.remove();
			}
		}
	};
}])
;